import { useEffect } from 'react'

const MAIN_BUTTON = 'Main Button'
const TOP_BAR_BUTTON = 'Top Bar Button'
const SIMULATOR_INTERACTION = 'simulatorInteraction'
const SIMULATOR = 'Simulator'
const STARTED_SIMULATION_ACTION = 'Started Simulation'
const COMPANY_INFO_STEP = 2
const COMMERCIAL_OFFER_STEP = 3
const COMMERCIAL_OFFER_URL = '/digital/simulate/commercial-offer'
const SMALL_BUSINESS_PLAN_CARD = 'small business plan card'
const MEDIUM_BUSINESS_PLAN_CARD = 'medium business plan card'
const LARGE_BUSINESS_PLAN_CARD = 'large business plan card'
const GYMPASS_GUIDE_DOWNLOAD = 'Gympass Guide Downloaded'

function getSimulationInteraction(action, step, page) {
  return {
    event: SIMULATOR_INTERACTION,
    category: SIMULATOR,
    action,
    step,
    page,
  }
}

function sendPush(data) {
  // eslint-disable-next-line no-unused-expressions
  dataLayer?.push(data)
}

function simulatorInteraction(label) {
  sendPush({
    event: SIMULATOR_INTERACTION,
    category: SIMULATOR,
    action: STARTED_SIMULATION_ACTION,
    label,
  })
}

function setExperiment(experimentId, variant) {
  sendPush({
    event: 'serverSideOptimizeReady',
    expId: experimentId,
    expVar: variant,
  })
}

function simulatorInteractionWithSteps(step, page, simulation) {
  const interactionWithSteps = getSimulationInteraction(
    `Step ${step} Completed`,
    step,
    page
  )

  sendPush({ ...interactionWithSteps, ...simulation })
}

function interactionWithCoupom(
  code,
  valid,
  discount,
  valueWithoutDiscount,
  valueWithDiscount
) {
  sendPush({
    ...getSimulationInteraction(
      'Coupon Entered',
      COMMERCIAL_OFFER_STEP,
      COMMERCIAL_OFFER_URL
    ),
    couponData: {
      code,
      valid,
      discount,
      valueWithoutDiscount,
      valueWithDiscount,
    },
  })
}

function interactionWithProposalDownload() {
  const proposalDownload = getSimulationInteraction(
    'Proposal Downloaded',
    COMMERCIAL_OFFER_STEP,
    COMMERCIAL_OFFER_URL
  )

  sendPush(proposalDownload)
}

function interactionWithContactRequest() {
  const contactRequest = getSimulationInteraction(
    'Contact Requested',
    COMMERCIAL_OFFER_STEP,
    COMMERCIAL_OFFER_URL
  )

  sendPush(contactRequest)
}

function virtualPageView(page) {
  const intervalId = setInterval(() => {
    if (global.dataLayer !== undefined) {
      sendPush({
        event: 'virtualPageView',
        page,
      })
      clearInterval(intervalId)
    }
  }, 1000)
}

export default function useDataLayer() {
  useEffect(() => {
    window.dataLayer = window.dataLayer || []
  })

  return {
    events: {
      simulatorInteraction,
      simulatorInteractionWithSteps,
      virtualPageView,
      interactionWithCoupom,
      interactionWithProposalDownload,
      interactionWithContactRequest,
      setExperiment,
    },
    values: {
      MAIN_BUTTON,
      TOP_BAR_BUTTON,
      COMPANY_INFO_STEP,
      COMMERCIAL_OFFER_STEP,
      SMALL_BUSINESS_PLAN_CARD,
      MEDIUM_BUSINESS_PLAN_CARD,
      LARGE_BUSINESS_PLAN_CARD,
      GYMPASS_GUIDE_DOWNLOAD,
    },
  }
}
